<template>
  <div class="login">
    <!--  -->
    <HelloWorld :keys="text"></HelloWorld>
    <!--  -->
    <div class="body">
      <div class="body-cen" style="">
        <div class="body-tel">手机号：</div>
        <el-input
          maxlength="11"
          v-model="tel"
          placeholder="请输入手机号码"
        ></el-input>
        <div class="body-tel">短信验证码：</div>
        <el-input @blur="pageYz()" placeholder="请输入验证码" v-model="input">
          <template slot="append">
            <div class="yzm pointer" @click="addcode">
              {{ sms == 60 ? "获取验证码" : sms + "后获取" }}
            </div>
          </template>
        </el-input>
        <div class="body-tel">新密码：</div>
        <el-input
          v-model="pwd"
          show-password
          placeholder="请输入新密码"
        ></el-input>
        <div class="body-tel">确认密码：</div>
        <el-input
          v-model="pwds"
          show-password
          placeholder="请再次输入新密码"
        ></el-input>
        <div
          @click="pageOk()"
          style="
            width: 50%;
            margin: 80px auto;
            background-color: #c7171e;
            padding: 11px 0;
            border-radius: 8px;
            text-align: center;
            color: #fff;
          "
        >
          完成
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HelloWorld from "@/components/HelloWorld.vue";
import Footer from "@/components/footer.vue";
export default {
  name: "Login",
  data() {
    return {
      tel: "",
      input: "", //验证码
      pwd: "", //密码
      pwds: "",
      sms: 60,
      checked: true,
      text: "忘记密码",
    };
  },
  components: {
    HelloWorld,
    Footer,
  },
  mounted() {},
  methods: {
    page(e) {
      this.$router.push({
        name: e,
        query: {
          id: 1,
        },
      });
    },
    // 获取验证码
    addcode() {
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (this.tel == "") {
        this.$message("请填写手机号");
      } else if (!reg_tel.test(this.tel)) {
        this.$message("请填写正确的手机号");
      } else if (this.sms != 60) {
        this.$message("请倒计时完毕再获取");
      } else {
        this.$apis
          .send({
            mobile: this.tel,
            event: "resetpwd",
          })
          .then((res) => {
            if (res.code == 1) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
          });
        let del = setInterval(() => {
          this.sms--;
          if (this.sms == 0) {
            this.sms = 60;
            clearInterval(del);
          }
        }, 1000);
      }
    },
    // 校验验证码
    pageYz() {
      this.$apis
        .check({
          mobile: this.tel,
          event: "resetpwd",
          captcha: this.input,
        })
        .then(() => {});
    },
    // 重置密码
    pageOk() {
      if (this.pwds == this.pwd) {
        this.$apis
          .resetpwd({
            mobile: this.tel,
            newpassword: this.pwds,
            captcha: this.input,
          })
          .then((res) => {
            if (res.code == 1) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }

            this.$router.go(-1);
          });
      } else {
        this.$message.error("两次输入的密码不同，请重新输入");
      }
    },
  },
};
</script>
<style scoped='scoped'>
/* body */
.body {
  width: 50%;
  margin: 0 auto;
  padding: 56px 0;
}
.el-input >>> .el-input__inner {
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0;
  padding: 0;
  font-size: 18px;
  margin-top: 8px;
  background-color: transparent;
}
.el-input >>> .el-input-group__append {
  background-color: transparent;
  color: #fff;
  border: 1px solid transparent;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0px;
  padding: 0;
}
.yzm {
  padding: 7px 16px;
  border-radius: 8px;
  font-size: 12px;
  background-color: #c7171e;
}
.body-tel {
  margin-top: 24px;
  font-size: 20px;
}
.body-cen {
  width: 50%;
  margin: 50px auto;
}

.login {
  background-color: #f5f5f5;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
}
h2 {
  font-size: 18px;
  color: #000;
}
/* 顶部 */
.option {
  color: #c7171e;
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
  .body-cen {
    width: 70%;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  /* body */
  .body {
    width: 100%;
  }
  .body-cen {
    width: 60%;
  }
}
@media only screen and (max-width: 767px) {
  /* body */
  .body {
    width: 100%;
  }
  .body-cen {
    width: 80%;
  }
}
</style>
